<script setup lang="tsx">
import { ref, watchEffect } from "vue";
import { mapState } from "../../context/context";

const props = withDefaults(
  defineProps<{
    color?: string;
  }>(),
  {}
);

const mappedState = mapState(["color.fontReverse"]);

const color = ref();

watchEffect(() => {
  color.value = props.color || mappedState["color.fontReverse"].value;
});
</script>

<template>
  <!-- 不设置 width="48" height="48" 自适应父元素 -->
  <!-- viewBox : x y width height , 可重设 viewBox 切除四周多余空白 -->
  <svg
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    preserveAspectRatio="none"
    fill="none"
    :style="{
      display: 'block',
      transformOrigin: 'center'
    }"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24 4C12.9587 4 4 12.9587 4 24C4 35.0413 12.9587 44 24 44C35.0413 44 44 35.0413 44 24C44 12.9587 35.0413 4 24 4ZM2 24C2 11.8542 11.8542 2 24 2C36.1458 2 46 11.8542 46 24C46 36.1458 36.1458 46 24 46C11.8542 46 2 36.1458 2 24Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24 13C23.45 13 23 13.45 23 14V29C23 29.55 23.45 30 24 30C24.55 30 25 29.55 25 29V14C25 13.45 24.55 13 24 13Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24 32C23.45 32 23 32.45 23 33V34C23 34.55 23.45 35 24 35C24.55 35 25 34.55 25 34V33C25 32.45 24.55 32 24 32Z"
      :fill="color"
    />
  </svg>
</template>
